var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState, useRef, createRef } from 'react';
import { createPortal } from 'react-dom';
import SolidColours from './SolidColours';
import CustomiseModal from './CustomiseModal';
import { deleteURLParam, generateUID, setURLParam } from '../../helpers/urlHelpers';
import DynamicImage from './DynamicImage';
import { lockBody, unlockBody } from '../../helpers/bodyLock';
import ComponentSelector from './ComponentSelector';
import AddToCartButton from '../atoms/AddToCartButton';
import AddOnsSelector from './AddOnsSelector';
import ExportCanvas from './ExportProductCanvas';
import html2canvas from 'html2canvas';
import { findVariantByColourName, extractImages, findAllColourSwatches, mapComponentVariants, getPossibleParams, findFirstAvailableVariants, findSelectedVariants, getVariantsFromURL } from '../baseHelpers';
import s3 from '../../helpers/awsConfig';
import ExportAddOnsCanvas from './ExportAddOnsCanvas';
const CustomiserBase = ({ strings, solidColoursContainer, baseProduct, bundleComponents, addOns, dynamicImageContainer, componentSelectContainer, addOnsContainer, thumbnailContainer, colourSwatchOrder, settings }) => {
    // Current product state
    const [currentSelectedBundle, setCurrentSelectedBundle] = useState(null);
    const [commonColours, setCommonColours] = useState([]);
    const [allImages, setAllImages] = useState([]);
    const [loadingNewPart, setLoadingNewPart] = useState(false);
    // Extras
    const [currentAddOns, setCurrentAddOns] = useState([]);
    const [monogrammingBasePrice, setMonogrammingBasePrice] = useState(null);
    const [monogrammingActive, setMonogrammingActive] = useState(false);
    // Modal state
    const [modalOpen, setModalOpen] = useState(false);
    const [steps, setSteps] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);
    const [monogrammingStepIndex, setMonogrammingStepIndex] = useState(0);
    const [addOnStepIndex, setAddOnStepIndex] = useState(0);
    // Export
    const exportCanvasRef = useRef(null);
    const exportAddOnsCanvasRef = useRef(addOns.map(() => createRef()));
    const [thumbnailArtwork, setThumbnailArtwork] = useState('');
    const [addOnArtwork, setAddOnArtwork] = useState([]);
    const [uniqueID, setUniqueID] = useState(null);
    // Mongramming
    const [disableBannedWord, setDisableBadWord] = useState(false);
    // Generating Thumbnmails
    const [bundleEdited, setBundleEdited] = useState({ count: 0, context: 'main', element: '' });
    const debounceTimeoutRef = useRef(null);
    const debounce = (func, delay) => {
        clearTimeout(debounceTimeoutRef.current);
        debounceTimeoutRef.current = setTimeout(func, delay);
    };
    const selectSolidColor = (colorName) => {
        const newBundle = currentSelectedBundle;
        newBundle.forEach((bundleProd, index) => {
            const variantsByColour = findVariantByColourName(bundleComponents[index].components, colorName, newBundle[index]);
            if (Object.keys(variantsByColour).length === 0 || variantsByColour === undefined) {
                newBundle[index] = currentSelectedBundle[index];
            }
            else {
                newBundle[index] = variantsByColour;
            }
        });
        setCurrentSelectedBundle([...newBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'part' });
    };
    const selectPartColor = (product, variant, prodIndex) => {
        const newBundle = currentSelectedBundle;
        const updatedBundle = Object.assign(Object.assign({}, newBundle[prodIndex]), { [product.component]: newBundle[prodIndex][product.component].map((innerProduct) => {
                if (innerProduct.part === product.part) {
                    return Object.assign(Object.assign({}, innerProduct), { selectedVariant: variant });
                }
                return innerProduct;
            }) });
        // set new bundle
        newBundle[prodIndex] = updatedBundle;
        setCurrentSelectedBundle([...newBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'part' });
    };
    // Modal Functionality
    const openModal = () => {
        setModalOpen(true);
        lockBody();
    };
    const closeModal = () => {
        setModalOpen(false);
        setCurrentStep(0);
        unlockBody();
    };
    const goToNextStep = () => {
        setCurrentStep(currentStep + 1);
    };
    const goToPreviousStep = () => {
        setCurrentStep(currentStep - 1);
    };
    // Component Select
    const selectNewComponent = (componentName, newProductName, prodIndex) => {
        setLoadingNewPart(true);
        const selectedComponent = bundleComponents[prodIndex].components.find((component) => component.name == componentName);
        const selectedProduct = selectedComponent.products.find((product) => product.part_type == newProductName);
        // Check if new part is available in the same colour
        const currentColour = currentSelectedBundle[prodIndex][componentName][0].selectedVariant.colour_swatch.name;
        const selectedVariants = [];
        if (selectedProduct.inner_parts) {
            selectedProduct.inner_parts.products.forEach((innerProduct) => {
                let found = false;
                innerProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == currentColour) {
                        selectedVariants.push({
                            selectedVariant: innerVariant,
                            product: selectedProduct.part_type,
                            component: componentName,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            monogramming: innerProduct.monogramming,
                        });
                        found = true;
                    }
                });
                if (!found) {
                    let findAvailable = false;
                    innerProduct.variants.forEach((innerVariant) => {
                        if (!findAvailable && innerVariant.available) {
                            selectedVariants.push({
                                selectedVariant: innerVariant,
                                product: selectedProduct.part_type,
                                component: componentName,
                                part: innerProduct.part_type,
                                otherVariants: innerProduct.variants,
                                title: innerProduct.title,
                                monogramming: innerProduct.monogramming,
                            });
                            findAvailable = true;
                        }
                    });
                }
            });
        }
        else {
            let found = false;
            selectedProduct.variants.forEach((innerVariant) => {
                if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == currentColour) {
                    selectedVariants.push(Object.assign(Object.assign({ selectedVariant: innerVariant, component: componentName, otherVariants: selectedProduct.variants }, selectedProduct), { product: selectedProduct.part_type, part: selectedProduct.part_type, title: selectedProduct.title, monogramming: selectedProduct.monogramming }));
                    found = true;
                }
            });
            if (!found) {
                let findAvailable = false;
                selectedProduct.variants.forEach((innerVariant) => {
                    if (!findAvailable && innerVariant.available) {
                        selectedVariants.push({
                            selectedVariant: innerVariant,
                            component: componentName,
                            product: selectedProduct.part_type,
                            part: selectedProduct.part_type,
                            otherVariants: selectedProduct.variants,
                            title: selectedProduct.title,
                            monogramming: selectedProduct.monogramming,
                        });
                        findAvailable = true;
                    }
                });
            }
        }
        // Find old componnent in URL and remove
        removeOldParamsForComponent(componentName, prodIndex);
        const newBundle = currentSelectedBundle;
        newBundle[prodIndex] = Object.assign(Object.assign({}, currentSelectedBundle[prodIndex]), { [componentName]: selectedVariants });
        // set new bundle
        setCurrentSelectedBundle([...newBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'part' });
    };
    const removeOldParamsForComponent = (componentName, prodIndex) => {
        const paramToDelete = [];
        if (currentSelectedBundle[prodIndex][componentName].length > 1) {
            currentSelectedBundle[prodIndex][componentName].forEach((item) => {
                paramToDelete.push(`${prodIndex + 1}--${componentName}--${item.product}--${item.part}`);
            });
        }
        else {
            currentSelectedBundle[prodIndex][componentName].forEach((item) => {
                paramToDelete.push(`${prodIndex + 1}--${componentName}--${item.part}`);
            });
        }
        paramToDelete.forEach((key) => {
            deleteURLParam(key);
        });
    };
    // ADD ONS
    const toggleAddOnProduct = (addOn) => {
        const current = currentAddOns.find((add) => add.part_type == addOn.part_type);
        if (current) {
            // Remove from the state
            setCurrentAddOns((prevItems) => prevItems.filter((item) => item.part_type != addOn.part_type));
        }
        else {
            // Add the addOn
            const newAddOn = {};
            newAddOn.isSelected = true;
            newAddOn.price = addOn.price;
            newAddOn.part_type = addOn.part_type;
            newAddOn.handle = addOn.handle;
            newAddOn.compare_at_price = addOn.compare_at_price;
            if (addOn.inner_parts) {
                newAddOn.products = addOn.inner_parts.products.map((innerProduct) => {
                    return {
                        selectedVariant: innerProduct.variants[0],
                        product: addOn.part_type,
                        part: innerProduct.part_type,
                        otherVariants: innerProduct.variants,
                        title: innerProduct.title,
                    };
                });
                newAddOn.products = [
                    ...newAddOn.products,
                    {
                        selectedVariant: addOn.variants[0],
                        product: addOn.part_type,
                        part: 'parent-product',
                        otherVariants: addOn.variants,
                        title: addOn.title,
                    },
                ];
            }
            else {
                newAddOn.products = [
                    {
                        selectedVariant: addOn.variants[0],
                        product: addOn.part_type,
                        part: 'parent-product',
                        otherVariants: addOn.variants,
                        title: addOn.title,
                    },
                ];
            }
            newAddOn.selectedPart = newAddOn.products[0];
            setCurrentAddOns((prevItems) => [...prevItems, newAddOn]);
        }
        setBundleEdited({ count: bundleEdited.count + 1, context: '-add-on', element: '' });
    };
    const setSelectedAddOnPart = (addOn, product) => {
        setCurrentAddOns((prevItems) => prevItems.map((item) => (item.part_type === addOn.part_type ? Object.assign(Object.assign({}, item), { selectedPart: product }) : item)));
        setBundleEdited({ count: bundleEdited.count + 1, context: '-add-on', element: '' });
    };
    const selectAddOnPartColor = (addOn, product, variant) => {
        setCurrentAddOns((prevItems) => prevItems.map((item) => item.part_type === addOn.part_type
            ? Object.assign(Object.assign({}, item), { products: item.products.map((innerProduct) => {
                    const isCurrentProduct = innerProduct.part == product;
                    return Object.assign(Object.assign({}, innerProduct), { selectedVariant: isCurrentProduct ? variant : innerProduct.selectedVariant });
                }) }) : item));
        setBundleEdited({ count: bundleEdited.count + 1, context: '-add-on', element: '' });
    };
    const goToAddOn = (type, prodIndex) => {
        if (type == 'add-on') {
            const selectedAddOn = addOns[prodIndex];
            const current = currentAddOns.find((addItem) => addItem.part_type == selectedAddOn.part_type);
            if (current) {
                toggleAddOnProduct(selectedAddOn);
            }
            else {
                setCurrentStep(addOnStepIndex);
                openModal();
                toggleAddOnProduct(selectedAddOn);
            }
        }
        else if (type == 'monogramming') {
            setCurrentStep(monogrammingStepIndex);
            openModal();
        }
    };
    // MONOGRAMMING
    const toggleMonogramming = (componentKey, productIndex, bundleIndex, side) => {
        const updatedBundle = currentSelectedBundle;
        if (updatedBundle[bundleIndex][componentKey][productIndex][side].included == true) {
            updatedBundle[bundleIndex][componentKey][productIndex][side].included = false;
            updatedBundle[bundleIndex][componentKey][productIndex][side].selected = false;
            updatedBundle[bundleIndex][componentKey][productIndex][side].value = '';
            updatedBundle[bundleIndex][componentKey][productIndex][side].emojis = updatedBundle[bundleIndex][componentKey][productIndex][side].emojis.map((emoji) => (Object.assign(Object.assign({}, emoji), { selected: false })));
        }
        else {
            updatedBundle[bundleIndex][componentKey][productIndex][side].included = true;
            updatedBundle[bundleIndex][componentKey][productIndex][side].selected = true;
        }
        setCurrentSelectedBundle([...updatedBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'mongram' });
    };
    const editMonogramming = (componentKey, index, newValue, maxLength, bundleIndex, side) => {
        // Crop to max length
        if (newValue.length > maxLength) {
            newValue = newValue.slice(0, maxLength);
        }
        // Remove invalid characters
        const validCharacters = /^[A-Za-z0-9 `~!@#$%^&*()\-_=+\[\]{}\\|;:'",<.>\/?]*$/;
        if (!validCharacters.test(newValue)) {
            newValue = newValue.replace(/[^A-Za-z0-9 `~!@#$%^&*()\-_=+\[\]{}\\|;:'",<.>\/?]/g, '');
        }
        // Check for bad words
        const enteredPhrase = newValue.toLowerCase().split(' ');
        let foundBad = false;
        enteredPhrase.forEach((word) => {
            if (!foundBad) {
                if (settings.banned_words.includes(word.replace(/\s+/g, '')) || settings.banned_words.includes(word) || settings.banned_words.includes(newValue)) {
                    setDisableBadWord(true);
                    foundBad = true;
                }
                else {
                    setDisableBadWord(false);
                }
            }
        });
        const updatedBundle = currentSelectedBundle;
        updatedBundle[bundleIndex][componentKey][index][side].value = newValue;
        setCurrentSelectedBundle([...updatedBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'mongram' });
    };
    const toggleEmoji = (componentKey, productIndex, emojiIndex, bundleIndex, side) => {
        const updatedBundle = currentSelectedBundle;
        const currentState = updatedBundle[bundleIndex][componentKey][productIndex][side].emojis[emojiIndex].selected;
        updatedBundle[bundleIndex][componentKey][productIndex][side].emojis = updatedBundle[bundleIndex][componentKey][productIndex][side].emojis.map((item) => (Object.assign(Object.assign({}, item), { selected: false })));
        updatedBundle[bundleIndex][componentKey][productIndex][side].emojis[emojiIndex].selected = !currentState;
        setCurrentSelectedBundle([...updatedBundle]);
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'mongram' });
    };
    const checkIfHasMonogramming = (allProducts, alreadySet) => {
        if (alreadySet)
            return alreadySet;
        let monogrammingPrice = 0;
        allProducts.forEach((product) => {
            product.products.forEach((element) => {
                if (element.inner_parts) {
                    return checkIfHasMonogramming([element.inner_parts], alreadySet);
                }
                else {
                    if (element.monogramming && element.monogramming.price) {
                        monogrammingPrice = element.monogramming.price;
                    }
                }
            });
        });
        setMonogrammingBasePrice(monogrammingPrice);
        return monogrammingPrice != null;
    };
    // SWATCHES
    const sortSwatches = (swatches) => {
        const orderMap = new Map(colourSwatchOrder.map((name, index) => [name, index]));
        return swatches.slice().sort((a, b) => {
            var _a, _b;
            return ((_a = orderMap.get(a.name)) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER) - ((_b = orderMap.get(b.name)) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER);
        });
    };
    // Sort variants by colour order
    const sortVariantsBySwatch = (variants) => {
        const orderMap = new Map(colourSwatchOrder.map((name, index) => [name, index]));
        return variants.slice().sort((a, b) => {
            var _a, _b, _c, _d, _e, _f;
            const aName = (_b = (_a = a.colour_swatch) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
            const bName = (_d = (_c = b.colour_swatch) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
            return ((_e = orderMap.get(aName)) !== null && _e !== void 0 ? _e : Number.MAX_SAFE_INTEGER) - ((_f = orderMap.get(bName)) !== null && _f !== void 0 ? _f : Number.MAX_SAFE_INTEGER);
        });
    };
    // MODAL STEPS
    const generateModalSteps = (baseComponents, bundle) => {
        const initSteps = [];
        const parentProducts = [];
        baseComponents.forEach((bundleProd) => {
            parentProducts.push(baseComponents.length > 1 ? bundleProd.product.giftset_part_title : bundleProd.product.title);
        });
        // Add steps to choose part products
        function configureInnerPartStep(componentGroup, bundleGroup, index) {
            if (componentGroup.products.length > 1) {
                const currentProduct = bundleGroup[componentGroup.name].length ? bundleGroup[componentGroup.name][0].product : null;
                const existingStep = initSteps.find((step) => step.title == `${strings.part_choose_prefix} ${componentGroup.name}`);
                if (existingStep) {
                    const existingIndex = initSteps.indexOf(existingStep);
                    initSteps[existingIndex] = {
                        title: `${strings.part_choose_prefix} ${componentGroup.name}`,
                        stepInfo: {
                            type: 'product-select',
                            selected: [...existingStep.stepInfo.selected, currentProduct],
                            partButtons: [
                                ...existingStep.stepInfo.partButtons,
                                componentGroup.products.map((product) => {
                                    return {
                                        title: product.title,
                                        part_type: product.part_type,
                                        component: componentGroup.name,
                                        prodIndex: index,
                                    };
                                }),
                            ],
                            parentProducts: [...existingStep.stepInfo.parentProducts, baseComponents.length > 1 ? componentGroup.products[0].giftset_part_title : componentGroup.products[0].parent_product],
                        },
                    };
                }
                else {
                    initSteps.push({
                        title: `${strings.part_choose_prefix} ${componentGroup.name}`,
                        stepInfo: {
                            type: 'product-select',
                            selected: [currentProduct],
                            partButtons: [
                                componentGroup.products.map((product) => {
                                    return {
                                        title: product.title,
                                        part_type: product.part_type,
                                        component: componentGroup.name,
                                        prodIndex: index,
                                    };
                                }),
                            ],
                            parentProducts: [baseComponents.length > 1 ? componentGroup.products[0].giftset_part_title : componentGroup.products[0].parent_product],
                        },
                    });
                }
            }
        }
        let showColourStep = false;
        bundle.forEach((bundleGroup, index) => {
            baseComponents[index].components.forEach((innerComponent) => {
                configureInnerPartStep(innerComponent, bundleGroup, index);
                innerComponent.products.forEach((innerProd) => {
                    if (innerProd.variants.length > 1) {
                        showColourStep = true;
                    }
                });
            });
        });
        // Add step to choose colour of parts
        if (showColourStep) {
            initSteps.push({
                title: strings.colour_choose_title,
                stepInfo: {
                    type: 'colour-select',
                    parentProducts: parentProducts,
                },
            });
        }
        function configureMonogrammingStep(bundleGroup, index) {
            for (const component in bundleGroup) {
                const existingStep = initSteps.find((step) => step.title == strings.monogramming_title);
                bundleGroup[component].forEach((componentProd) => {
                    if (componentProd.monogramming && componentProd.monogramming.variant_id) {
                        const relatedComponent = bundleComponents[index].components.find((comp) => comp.name == component);
                        if (existingStep) {
                            const existingIndex = initSteps.indexOf(existingStep);
                            initSteps[existingIndex] = {
                                title: strings.monogramming_title,
                                stepInfo: {
                                    type: 'monogramming',
                                    parentProducts: [...existingStep.stepInfo.parentProducts, baseComponents.length > 1 ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            };
                        }
                        else {
                            initSteps.push({
                                title: strings.monogramming_title,
                                stepInfo: {
                                    type: 'monogramming',
                                    parentProducts: [baseComponents.length > 1 ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            });
                        }
                    }
                });
            }
        }
        function configureBackMonogrammingStep(bundleGroup, index) {
            for (const component in bundleGroup) {
                const existingStep = initSteps.find((step) => step.title == strings.monogramming_back_title);
                bundleGroup[component].forEach((componentProd) => {
                    if (componentProd.monogramming_back && componentProd.monogramming_back.variant_id) {
                        const relatedComponent = bundleComponents[index].components.find((comp) => comp.name == component);
                        if (existingStep) {
                            const existingIndex = initSteps.indexOf(existingStep);
                            initSteps[existingIndex] = {
                                title: strings.monogramming_back_title,
                                stepInfo: {
                                    type: 'monogramming-back',
                                    parentProducts: [...existingStep.stepInfo.parentProducts, baseComponents.length > 1 ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            };
                        }
                        else {
                            initSteps.push({
                                title: strings.monogramming_back_title,
                                stepInfo: {
                                    type: 'monogramming-back',
                                    parentProducts: [baseComponents.length > 1 ? relatedComponent.products[0].giftset_part_title : relatedComponent.products[0].parent_product],
                                },
                            });
                        }
                    }
                });
            }
        }
        // Add monogramming
        if (monogrammingBasePrice != null) {
            setMonogrammingStepIndex(initSteps.length);
            bundle.forEach((bundleGroup, index) => {
                configureMonogrammingStep(bundleGroup, index);
                configureBackMonogrammingStep(bundleGroup, index);
            });
        }
        // Add add ons
        if (addOns.length) {
            setAddOnStepIndex(initSteps.length);
            initSteps.push({
                title: strings.add_ons_title,
                stepInfo: {
                    type: 'add-ons',
                },
            });
        }
        return initSteps;
    };
    // USEEFFECT: First Load
    useEffect(() => {
        //  @ts-ignore
        const parsedUrl = new URL(window.location);
        const queryParams = parsedUrl.searchParams;
        if (bundleComponents.length) {
            const selectedBundle = [];
            // Check if in url and if correct
            if (queryParams.size > 0) {
                let allParams = [];
                bundleComponents.forEach((bundleProd, index) => {
                    const possibleParams = getPossibleParams(bundleProd.components, `${index + 1}--`);
                    allParams = [...allParams, ...possibleParams];
                });
                // Loop through existing params and delete anything not valid
                for (const [key, value] of queryParams.entries()) {
                    if (key == 'variant') {
                        continue;
                    }
                    else if (!allParams.includes(key)) {
                        deleteURLParam(key);
                    }
                }
                //  @ts-ignore
                const newURL = new URL(window.location);
                const remainingParams = newURL.searchParams;
                let hasMonogramming = false;
                if (remainingParams.size > 0) {
                    bundleComponents.forEach((bundleProd, prodIndex) => {
                        // If there are parts in the url
                        const selectedVariants = getVariantsFromURL(queryParams, bundleProd.components, prodIndex);
                        selectedBundle.push(selectedVariants);
                        // Check if has monogramming
                        hasMonogramming = checkIfHasMonogramming(bundleProd.components, hasMonogramming);
                    });
                }
                else {
                    bundleComponents.forEach((bundleProd) => {
                        let selectedVariants;
                        if (bundleProd.default_parts.length) {
                            // If default parts have been selected
                            selectedVariants = findSelectedVariants(bundleProd.components, bundleProd.default_parts);
                        }
                        else {
                            // Otherwise, chose the first available variant for each component
                            selectedVariants = findFirstAvailableVariants(bundleProd.components);
                        }
                        selectedBundle.push(selectedVariants);
                        // Check if has monogramming
                        hasMonogramming = checkIfHasMonogramming(bundleProd.components, hasMonogramming);
                    });
                }
            }
            else {
                let hasMonogramming = false;
                bundleComponents.forEach((bundleProd) => {
                    let selectedVariants;
                    if (queryParams.size > 0) {
                        return;
                    }
                    else if (bundleProd.default_parts.length) {
                        // If default parts have been selected
                        selectedVariants = findSelectedVariants(bundleProd.components, bundleProd.default_parts);
                    }
                    else {
                        // Otherwise, chose the first available variant for each component
                        selectedVariants = findFirstAvailableVariants(bundleProd.components);
                    }
                    selectedBundle.push(selectedVariants);
                    // Check if has monogramming
                    hasMonogramming = checkIfHasMonogramming(bundleProd.components, hasMonogramming);
                });
            }
            setCurrentSelectedBundle(selectedBundle);
            const uid = generateUID();
            setUniqueID(uid);
        }
    }, []);
    useEffect(() => {
        setBundleEdited({ count: bundleEdited.count + 1, context: 'main', element: 'first-load' });
        setThumbnailArtwork(`https://s3.ap-southeast-2.amazonaws.com/bundle-images.frank-green/${baseProduct.handle}-${uniqueID}.png`);
        setAddOnArtwork(addOns.map((addOn, index) => `https://s3.ap-southeast-2.amazonaws.com/bundle-images.frank-green/${baseProduct.handle}-add-on${index}-${uniqueID}.png`));
    }, [uniqueID]);
    // USEEFFECT: Bundle Updated
    useEffect(() => {
        if (currentSelectedBundle && bundleEdited.context == 'main') {
            // if colours or parts have been updated, redefine the url and solid colour options
            if (bundleEdited.element == 'part' || bundleEdited.element == 'first-load') {
                const mappedVariants = mapComponentVariants(currentSelectedBundle);
                // @ts-ignore
                const parsedUrl = new URL(window.location);
                const queryParams = parsedUrl.searchParams;
                for (const [key, value] of queryParams.entries()) {
                    deleteURLParam(key);
                }
                if (mappedVariants) {
                    for (const key in mappedVariants) {
                        setURLParam(key, mappedVariants[key]);
                    }
                }
                // Get sold colours if solid colours container
                if (solidColoursContainer) {
                    let allArrays = [];
                    currentSelectedBundle.forEach((bundleProduct) => {
                        for (const component in bundleProduct) {
                            bundleProduct[component].forEach((componentProd) => {
                                allArrays = [...allArrays, componentProd.otherVariants];
                            });
                        }
                    });
                    const selectable = allArrays.filter((colourArray) => colourArray.length > 1 && colourArray.every((innerObj) => { var _a; return (_a = innerObj.colour_swatch) === null || _a === void 0 ? void 0 : _a.name; }));
                    const allColourSwatches = findAllColourSwatches(selectable);
                    // FGBAU-367 have updated this to be all swatches. Old function: findCommonColourSwatches
                    const sortedAllSwatches = sortSwatches(allColourSwatches);
                    setCommonColours(sortedAllSwatches);
                }
            }
            if (bundleEdited.element == 'monogram' || bundleEdited.element == 'first-load') {
                // Check if monogramming is active
                setMonogrammingActive(false);
                currentSelectedBundle.forEach((bundleProduct) => {
                    for (const component in bundleProduct) {
                        bundleProduct[component].forEach((componentProd) => {
                            var _a, _b, _c;
                            const selectedEmoji = (_b = (_a = componentProd.monogramming) === null || _a === void 0 ? void 0 : _a.emojis) === null || _b === void 0 ? void 0 : _b.some((emoji) => emoji.selected);
                            if (componentProd.monogramming && (((_c = componentProd.monogramming.value) === null || _c === void 0 ? void 0 : _c.length) > 0 || selectedEmoji)) {
                                setMonogrammingActive(true);
                            }
                        });
                    }
                });
            }
            // Update images
            const allVariantImages = [];
            bundleComponents.forEach((bundleProduct, index) => {
                const imageArray = extractImages(currentSelectedBundle[index], bundleProduct.components, bundleProduct.product.handle);
                allVariantImages.push(imageArray);
            });
            setAllImages(allVariantImages);
            // Generate modal steps
            const initSteps = generateModalSteps(bundleComponents, currentSelectedBundle);
            setSteps(initSteps);
        }
    }, [currentSelectedBundle]);
    // FINAL ARTWORK
    const generateThumbnail = (context, fileName, index) => __awaiter(void 0, void 0, void 0, function* () {
        const currentRef = context === 'main' ? exportCanvasRef.current : exportAddOnsCanvasRef.current[index].current;
        if (currentRef === null) {
            return false;
        }
        try {
            const canvas = yield html2canvas(currentRef, { allowTaint: true, backgroundColor: null });
            const imgData = canvas.toDataURL('image/png');
            const artwork = yield uploadToImageS3(imgData, `${baseProduct.handle}${fileName}-${uniqueID}.png`);
            return true;
        }
        catch (err) {
            console.log(err);
            return false;
        }
    });
    useEffect(() => {
        debounce(() => {
            if (bundleEdited.element == 'first-load') {
                generateThumbnail('main', '');
                currentAddOns.forEach((addOnItem, index) => generateThumbnail('addOn', `-add-on${index}`, index));
            }
            else if (bundleEdited.context == 'main') {
                generateThumbnail('main', '');
            }
            else {
                currentAddOns.forEach((addOnItem, index) => generateThumbnail('addOn', `-add-on${index}`, index));
            }
        }, 500); // 500ms debounce delay
    }, [bundleEdited]);
    const convertToBlob = (dataURI) => {
        const binary = atob(dataURI.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: 'image/png' });
    };
    const uploadToImageS3 = (dataURI, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        const blob = convertToBlob(dataURI);
        const params = {
            Bucket: 'bundle-images.frank-green',
            Key: fileName,
            Body: blob,
            ContentType: 'image/png',
            ACL: 'public-read',
        };
        try {
            const uploadResult = yield s3.upload(params).promise();
            return uploadResult.Location;
        }
        catch (error) {
            console.error('Error uploading to S3:', error);
            throw error;
        }
    });
    if (!currentSelectedBundle) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(AddToCartButton, { currentBundle: currentSelectedBundle, currentAddOns: currentAddOns, product: baseProduct, extraClass: 'pdp-atc', strings: strings, giftSetPrefix: settings.gift_set_properties, thumbnailArtwork: thumbnailArtwork, addOnArtwork: addOnArtwork, closeModal: closeModal, setUniqueID: setUniqueID, openModal: openModal, showCustomiseButton: steps.length > 0, generateThumbnail: generateThumbnail, disableBannedWord: disableBannedWord, bundleComponents: bundleComponents, checkoutImage: settings.checkout_bundle_image }),
        steps.length ? (React.createElement(CustomiseModal, { currentBundle: currentSelectedBundle, bundleComponents: bundleComponents, closeModal: closeModal, modalOpen: modalOpen, addOns: addOns, product: baseProduct, strings: strings, loadingNewPart: loadingNewPart, allImages: allImages, currentAddOns: currentAddOns, steps: steps, currentStep: currentStep, productHandle: baseProduct.handle, thumbnailArtwork: thumbnailArtwork, addOnArtwork: addOnArtwork, disableBannedWord: disableBannedWord, giftSetPrefix: settings.gift_set_properties, checkoutImage: settings.checkout_bundle_image, selectNewComponent: selectNewComponent, selectPartColor: selectPartColor, toggleAddOnProduct: toggleAddOnProduct, setSelectedAddOnPart: setSelectedAddOnPart, selectAddOnPartColor: selectAddOnPartColor, toggleMonogramming: toggleMonogramming, editMonogramming: editMonogramming, toggleEmoji: toggleEmoji, goToNextStep: goToNextStep, goToPreviousStep: goToPreviousStep, sortSwatches: sortVariantsBySwatch, setUniqueID: setUniqueID, generateThumbnail: generateThumbnail })) : null,
        createPortal(React.createElement(React.Fragment, null,
            React.createElement(DynamicImage, { currentAddOns: currentAddOns, allImages: allImages, productHandle: baseProduct.handle }),
            steps.length ? (React.createElement("button", { className: "fg-cust--customise-btn", onClick: openModal },
                React.createElement("div", { className: "badge__inner" }, strings.customise_title))) : null), dynamicImageContainer),
        solidColoursContainer &&
            createPortal(React.createElement(SolidColours, { commonColours: commonColours, selectSolidColor: selectSolidColor, currentBundle: currentSelectedBundle }), solidColoursContainer),
        componentSelectContainer &&
            createPortal(React.createElement(React.Fragment, null, bundleComponents.map((bundleProd, index) => (React.createElement(ComponentSelector, { key: `component-select--${index}`, components: bundleProd.components, strings: strings, currentBundle: currentSelectedBundle[index], currentIndex: index, selectNewComponent: selectNewComponent })))), componentSelectContainer),
        addOnsContainer &&
            createPortal(React.createElement(AddOnsSelector, { addOns: addOns, strings: strings, currentAddOns: currentAddOns, monogrammingBasePrice: monogrammingBasePrice, monogrammingActive: monogrammingActive, goToAddOn: goToAddOn }), addOnsContainer),
        thumbnailContainer &&
            createPortal(React.createElement(React.Fragment, null,
                React.createElement(ExportCanvas, { allImages: allImages, exportCanvasRef: exportCanvasRef, productHandle: baseProduct.handle }),
                currentAddOns.map((addOn, index) => (React.createElement(ExportAddOnsCanvas, { key: `add-on-canvas-${index}`, addOnItem: addOn, exportAddOnsCanvasRef: exportAddOnsCanvasRef.current[index] })))), thumbnailContainer)));
};
export default CustomiserBase;
